import React from "react";
import { motion } from "framer-motion";
import { Phone, MessageCircle, ArrowRight, ShieldCheck, Clock3 } from "lucide-react";
import CircuitPanel from "./CircuitPanel";

const WA = "https://wa.me/34617420491?text=" + encodeURIComponent(
  "Hola Moisés, me gustaría un presupuesto sin compromiso."
);

export default function Hero() {
  return (
    <section id="inicio" className="relative pt-28 lg:pt-32 pb-16 overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-60 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <div className="lg:col-span-7">
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            className="section-label mb-6"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-[#00E5FF] shadow-[0_0_8px_#00E5FF]" />
            Electricista certificado · Gran Canaria
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.05 }}
            className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.95] text-white"
          >
            Instalaciones eléctricas <br />
            <span className="text-[#E57C23]">precisas.</span>{" "}
            <span className="text-white/70">Sin sustos,</span>
            <br />
            <span className="text-white">sin sobreprecios.</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.15 }}
            className="mt-6 text-[17px] lg:text-lg text-[#9CA3AF] max-w-2xl leading-relaxed"
          >
            Soy <span className="text-white">Francisco Moisés</span>, técnico electricista con más
            de <span className="text-white">10 años</span> resolviendo instalaciones,
            averías y proyectos fotovoltaicos en <span className="text-white">Telde,
            Las Palmas, Vecindario, Ingenio y Arinaga</span>. Certificación, trato
            directo y respuesta el mismo día en urgencias.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.25 }}
            className="mt-9 flex flex-wrap items-center gap-3"
          >
            <a
              href={WA}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-whatsapp-btn"
              className="btn-copper"
            >
              <MessageCircle size={17} strokeWidth={2.4} />
              WhatsApp directo
              <ArrowRight size={16} />
            </a>
            <a href="tel:+34617420491" data-testid="hero-call-btn" className="btn-ghost-cyan">
              <Phone size={16} strokeWidth={2.2} />
              617 420 491
            </a>
            <a
              href="#contacto"
              data-testid="hero-budget-btn"
              className="text-sm text-white/70 hover:text-white transition-colors underline underline-offset-4 decoration-white/20 hover:decoration-[#00E5FF] px-2 py-2"
            >
              Solicitar presupuesto sin compromiso →
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-10 flex flex-wrap gap-6 text-sm text-[#9CA3AF]"
          >
            <div className="flex items-center gap-2">
              <ShieldCheck size={16} className="text-[#00E5FF]" />
              Certificación REBT
            </div>
            <div className="flex items-center gap-2">
              <Clock3 size={16} className="text-[#E57C23]" />
              Urgencias en el mismo día
            </div>
            <div className="flex items-center gap-2">
              <span className="h-1.5 w-1.5 rounded-full bg-white/50" />
              Presupuestos sin compromiso
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-5">
          <motion.div
            initial={{ opacity: 0, scale: 0.94 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.2, duration: 0.8, ease: [0.2, 0.8, 0.2, 1] }}
          >
            <CircuitPanel />
          </motion.div>
        </div>
      </div>

      <div className="divider-copper max-w-7xl mx-auto mt-16" />
    </section>
  );
}
